import { useLayoutEffect } from 'react';
const useAutoScrollConsoleToBottom = _ref => {
  let {
    divElementRef,
    scrollWhenAnyValueChanges
  } = _ref;
  useLayoutEffect(() => {
    const divElement = divElementRef.current;
    if (divElement == null) {
      return;
    }
    divElement.scrollTop = divElement.scrollHeight;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...scrollWhenAnyValueChanges, divElementRef]);
};
export default useAutoScrollConsoleToBottom;